import {
  SET_EDUCATION_RECOMMEND_BANNER,
  SET_EDUCATION_RECOMMEND_GROUPS,
  SET_EDUCATION_CATEGORY_TAGS,
  SET_EDUCATION_CATEGORY_GRADELIST,
  SET_EDUCATION_CATEGORY_LOADING,
  SET_EDUCATION_CATEGORY_ERROR,
  SET_EDUCATION_MINE_GRADELIST,
  SET_EDUCATION_MINE_LOADING,
  SET_EDUCATION_MINE_ERROR,
  OPERATION_EDUCATION_MINE_GRADELIST,
  SET_EDUCATION_DETAIL,
  SET_EDUCATION_RECOMMEND_LOADING,
  SET_EDUCATION_RECOMMEND_TAG_ERROR,
  SET_EDUCATION_PLAY_URL,
  SET_EDUCATION_PLAY_DATA_REPORT,
  SET_EDUCATION_COLLECT_REPORT,
  SET_EDUCATION_PAY_CREATE,
  SET_EDUCATION_PAY_RESULT,
  SET_EDUCATION_NEW_TAGS,
} from '../constants/education';

const initState = {
  recommend: {
    banner: null,
    groups: null,
    loading: false,
    error: false,
  },
  category: {
    tags: [],
    gradeList: [],
    pagenation: {
      count: 0,
      pageSize: 24,
      skip: 0,
      limit: 0,
    },
    error: false,
  },
  mine: {
    gradeList: [],
    pagenation: {
      count: 0,
      loading: true,
    },
    error: false,
  },
  detialInfo: {
    data: null,
    loading: false,
  },
  payUrl: null,
  collect: {
    data: null,
    loading: false,
  },
  payCreate: {
    data: null,
  },
  payResult: {
    data: null,
  },
  newTabs: [
    {
      name: '分类',
      route: 'category',
      icon: 'icon-category1_15',
      // component: EduCategory,
    },
    {
      name: '我的',
      route: 'mine',
      icon: 'icon-edu_mine',
      // component: EduMine,
    },
  ],
  eduLoading: false,
};

const education = (state = initState, action = {}) => {
  switch (action.type) {
    case SET_EDUCATION_RECOMMEND_BANNER:
      return {
        ...state,
        recommend: {
          ...state.recommend,
          banner: action.payload,
        },
      };
    case SET_EDUCATION_RECOMMEND_GROUPS:
      return {
        ...state,
        recommend: {
          ...state.recommend,
          groups: action.payload,
        },
      };
    case SET_EDUCATION_RECOMMEND_LOADING:
      return {
        ...state,
        recommend: {
          ...state.recommend,
          loading: action.payload,
        },
      };
    case SET_EDUCATION_RECOMMEND_TAG_ERROR:
      return {
        ...state,
        recommend: {
          error: action.payload,
        },
      };
    case SET_EDUCATION_CATEGORY_TAGS:
      return {
        ...state,
        category: {
          ...state.category,
          tags: action.payload || [],
        },
      };
    case SET_EDUCATION_CATEGORY_GRADELIST:
      // 分类翻页 各个tab指标一样证明翻页 否则证明是重新点击
      return {
        ...state,
        category: {
          ...state.category,
          gradeList:
            state.category.pagenation.subjectId === action.payload.subjectId &&
            state.category.pagenation.phaseId === action.payload.phaseId &&
            state.category.pagenation.gradeId === action.payload.gradeId &&
            state.category.pagenation.priceId === action.payload.priceId &&
            !action.payload.refresh
              ? [
                  ...state.category.gradeList,
                  ...((action.payload && action.payload.dataList) || []),
                ]
              : (action.payload && action.payload.dataList) || [],
          pagenation: {
            ...state.category.pagenation,
            count: action.payload.count,
            bizInfo: action.payload.bizInfo,
            subjectId: action.payload.subjectId,
            phaseId: action.payload.phaseId,
            gradeId: action.payload.gradeId,
            priceId: action.payload.priceId,
            loading: false,
          },
        },
      };
    case SET_EDUCATION_CATEGORY_LOADING:
      return {
        ...state,
        category: {
          ...state.category,
          pagenation: {
            ...state.category.pagenation,
            loading: action.payload,
          },
        },
      };
    case SET_EDUCATION_CATEGORY_ERROR:
      return {
        ...state,
        category: {
          ...state.category,
          pagenation: {
            ...state.category.pagenation,
            loading: false,
          },
          error: action.payload,
        },
      };
    case SET_EDUCATION_MINE_GRADELIST:
      return {
        ...state,
        mine: {
          ...state.mine,
          gradeList:
            state.mine.pagenation.tab === action.payload.tab && !action.payload.refresh
              ? [...state.mine.gradeList, ...((action.payload && action.payload.dataList) || [])]
              : (action.payload && action.payload.dataList) || [],
          pagenation: {
            ...state.mine.pagenation,
            count: action.payload.count,
            tab: action.payload.tab,
            loading: false,
          },
        },
      };
    case SET_EDUCATION_MINE_ERROR:
      return {
        ...state,
        mine: {
          ...state.mine,
          error: action.payload,
          pagenation: {
            ...state.mine.pagenation,
            loading: false,
          },
        },
      };
    case SET_EDUCATION_MINE_LOADING:
      return {
        ...state,
        mine: {
          ...state.mine,
          pagenation: {
            ...state.mine.pagenation,
            loading: action.payload,
          },
        },
      };
    case OPERATION_EDUCATION_MINE_GRADELIST:
      // eslint-disable-next-line no-case-declarations
      const targetList =
        state.mine &&
        state.mine.gradeList &&
        state.mine.gradeList.filter(
          item =>
            item.courseId !==
            (action.payload.tab === 'course'
              ? action.payload.myCourserIds[0].courserId
              : action.payload.myCollectIds[0].courserId),
        );
      return {
        ...state,
        mine: {
          ...state.mine,
          gradeList: targetList || [],
          pagenation: {
            ...state.mine.pagenation,
            count: state.mine.pagenation.count > 1 ? state.mine.pagenation.count - 1 : 0,
          },
        },
      };
    case SET_EDUCATION_DETAIL:
      return {
        ...state,
        detialInfo: action.payload,
      };
    case SET_EDUCATION_PLAY_URL:
      return {
        ...state,
        payUrl: action.payload,
      };
    case SET_EDUCATION_COLLECT_REPORT:
      return {
        ...state,
        collect: action.payload,
      };
    case SET_EDUCATION_PAY_CREATE:
      return {
        ...state,
        payCreate: action.payload,
      };
    case SET_EDUCATION_PAY_RESULT:
      return {
        ...state,
        payResult: action.payload,
      };
    case SET_EDUCATION_NEW_TAGS:
      return {
        ...state,
        newTabs:
          state.newTabs.length < 7 ? [...action.payload, ...state.newTabs] : [...state.newTabs],
      };
    default:
      return state;
  }
};

export default education;
